import type { RouteObject } from 'react-router';
import { READABLE_OFFLINE } from '../../core/pwa/works-offline';

/**
 * `/done`. One lazy chunk holding one screen — there is no list/detail split here the way
 * `containers.routes.tsx` has, because the archive *is* the list.
 *
 * The narrowing arrives as **query params** (`?contextId=`/`?projectId=`) rather than as path
 * segments, because it is a filter on one screen and not a different screen: `/done` and
 * `/done?projectId=7` are the same page showing more or less of itself, and a query param is what
 * lets the page's own "Clear" drop it without knowing this file's shape.
 *
 * **They no longer pass through the route at all**, which is the one thing that changed. Angular
 * bound them to component inputs, which worked only while the router carried
 * `withComponentInputBinding()` — a line whose loss was invisible to the type checker and would have
 * left the page permanently unnarrowed, which is why `archive.routes.spec.ts` navigated for real and
 * asserted the request the store issued rather than the component class. The React page reads
 * `useSearchParams()` itself, so there is no binding layer left to lose; the spec keeps the real
 * navigation anyway, because what it actually proves — that a query param reaches the API as a
 * narrowing — is still worth proving and is still invisible from this file alone.
 */
export const archiveRoutes: RouteObject[] = [
  {
    index: true,
    // 036 (issue 221, FR-021): readable offline — "the first page of done", which is what
    // `archive.store.ts`'s own re-read-before-write and `core/stored-views/allow-list.ts`'s own
    // `page=1`-only branch both scope this to.
    handle: { [READABLE_OFFLINE]: true },
    lazy: async () => ({ Component: (await import('./archive-page')).default }),
  },
];
